<template lang="pug">
.mypage
    .--center
        BtnBase(
            :label="isMypageLinked ? 'マイページはこちら' : 'マイページ連携はこちら'"
            add-class="--primary"
            is-icon=true
            @onClick="onClickMyPageBtn"
        )

    .mycardInfo
        .mycardInfo__inner
            .mycardInfo__header
                h2.mycardInfo__title CONTACT
                p.mycardInfo__description お電話でのお問い合わせ
            .mycardInfo__content
                p.mycardInfo__contentItem.--labelValue
                    span.mycardInfo__contentLabel 電話番号
                    span.mycardInfo__contentValue 0120-114-225
                p.mycardInfo__contentItem.--labelValue
                    span.mycardInfo__contentLabel 受付時間
                    span.mycardInfo__contentValue
                        | 10:00 - 19:00 (年中無休)
                        br.--sp
                        | ※年末年始を除く
</template>

<script setup>
    import BtnBase from '@/components/atoms/BtnBase.vue'
    import { getCurrentInstance } from 'vue'
    import { VueHelper } from '@/helpers/vue'
    import { useAuth } from '@/store/auth'

    defineProps({
        isMypageLinked: {
            type: Boolean,
            default: false,
        },
    })

    const _this = getCurrentInstance()
    const authStore = useAuth()

    const onClickMyPageBtn = () => {
        VueHelper.lock()
        const path = `/mypage-link?provision_shop_code=${authStore.LINELoginData.provisionShopCode}&brandsite=${authStore.LINELoginData.brandSite}`
        VueHelper.transition(_this.appContext.config.globalProperties, path)
    }
</script>

<style scoped lang="stylus">
.mycardInfo
    margin-top: 6rem
    color: white
    background-color: albion-navy

    .mycardInfo__inner
        display: flex
        align-items: center
        padding: 3rem 5rem

        +sp()
            flex-direction: column
            gap: 1.6rem
            padding: 3rem

        .mycardInfo__header
            display: flex
            flex-direction: column
            gap: .8rem
            padding-right: 6.8rem
            margin-right: 6.8rem
            border-right: 1px solid hsla(0, 0%, 100%, .3)

            +sp()
                flex-direction: row
                gap: 1rem
                align-items: unset
                justify-content: flex-start
                width: 100%
                padding-right: 0
                margin-right: 0
                border-right: none

            .mycardInfo__title
                font-family: "YakuHanJPs", "lunchtype22light", sans-serif
                font-size: 3rem
                line-height: 100%
                letter-spacing: .05em
                font-style: normal
                font-weight: 300

                +sp()
                    font-size: 2.6rem

            .mycardInfo__description
                flex: none
                flex-grow: 0
                align-self: stretch
                order: 0
                font-size: 1.4rem
                line-height: 180%
                letter-spacing: .04em
                font-style: normal
                font-weight: 400
                font-weight: 700

                +sp()
                    margin-top: auto
                    font-size: 1.2rem

        .mycardInfo__content
            flex: none
            flex-grow: 0
            align-self: stretch
            order: 0
            font-size: 1.4rem
            line-height: 180%
            letter-spacing: .04em
            font-style: normal
            font-weight: 400

            .mycardInfo__contentItem.--labelValue
                display: flex
                gap: .8rem

            .mycardInfo__contentLabel
                white-space: nowrap

            .mycardInfo__contentValue
                flex: 1
</style>
